import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  GET_ROLE,
  GET_ROLE_DETAILS,
  ADD_NEW_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  ROLE_USER_ASSIGN,
} from "./actionTypes.js";

import {
  getRoleSuccess,
  getRoleFail,
  getRoleDetailsSuccess,
  getRoleDetailsFail,
  addRoleFail,
  addRoleSuccess,
  updateRoleSuccess,
  updateRoleFail,
  deleteRoleSuccess,
  deleteRoleFail,
  roleUserAssignSuccess,
  roleUserAssignFail,
} from "./action.js"

import {
  roleListingApi,
  roleDetailsApi,
  addNewRole,
  updateRole,
  delRole,
  roleUserAssign,
} from "./roleApi.js"

function* fetchRole({ payload: length, page, sortOrder, sort }) {
  try {
    const response = yield call(roleListingApi, length, page, sortOrder, sort)
    yield put(getRoleSuccess(response))
  } catch (error) {
    yield put(getRoleFail(error))
  }
}

function* fetchRoleDetails({ payload: id }) {
  try {
    const response = yield call(roleDetailsApi, id)
    yield put(getRoleDetailsSuccess(response))
  } catch (error) {
    yield put(getRoleDetailsFail(error))
  }
}

function* onAddNewRole({ payload: role }) {
  try {
    const response = yield call(addNewRole, role)
    yield put(addRoleSuccess(response))
  } catch (error) {
    yield put(addRoleFail(error))
  }
}

function* onUpdateRole({ payload: id, role }) {
  try {
    const response = yield call(updateRole, id, role)
    yield put(updateRoleSuccess(response))
  } catch (error) {
    yield put(updateRoleFail(error))
  }
}

function* onDelRole({ payload}) {
  try {
    const response = yield call(delRole, payload)
    yield put(deleteRoleSuccess(response))
  } catch (error) {
    yield put(deleteRoleFail(error))
  }
}

function* onAssign({payload}) {
  try {
    const response = yield call(roleUserAssign, payload)
    yield put(roleUserAssignSuccess(response))
  } catch (error) {
    yield put(roleUserAssignFail(error))
  }
}

function* RoleSaga() {
  yield takeEvery(GET_ROLE, fetchRole)
  yield takeEvery(GET_ROLE_DETAILS, fetchRoleDetails)
  yield takeEvery(ADD_NEW_ROLE, onAddNewRole)
  yield takeEvery(UPDATE_ROLE, onUpdateRole)
  yield takeEvery(DELETE_ROLE, onDelRole)
  yield takeEvery(ROLE_USER_ASSIGN, onAssign)
}

export default RoleSaga
